import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import screenfull from "screenfull";
// import { onMounted } from "vue";
// const screenfullFunc = async () => {
//   if (screenfull.isEnabled) {
//     screenfull.toggle(); // 开启全屏
//   }
// };

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView))
}
}

})